(function () {
  'use strict';

  /*
    Motion theme dispatches "ajaxProduct:added" only after its AJAX
    add-to-cart request succeeds.

    This sends only a generic Microsoft Clarity event name.
    It does not send product, customer, cart, postal code, price,
    revenue, email, address, or other personal data.
  */
  document.addEventListener('ajaxProduct:added', function () {
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', 'confirmed_add_to_cart');
      }
    } catch (error) {
      // Analytics must never interfere with storefront functionality.
    }
  });
})();